/*
 * @Author: WLL
 * @Date: 2020-04-29 12:08:11
 * @LastEditors: WLL
 * @LastEditTime: 2020-04-29 14:02:36
 * @Description: http
 */
import axios from "axios";
import EventBus from "@/eventBus";
import store from "../store";

const service = axios.create({
  // 设置超时时间
  timeout: 60000
});

// 请求拦截
service.interceptors.request.use(
  config => {
    if (store.state.domain) {
      config.headers.domain = store.state.domain;
    }
    if (store.state.token) {
      config.headers.token = store.state.token;
    }
    if (store.state.username) {
      config.headers.username = store.state.username;
    }
    config.headers.clientType = "pc";
    return {
      ...config,
      url: `/api/v1/xinhua/${config.url}`
    };
  },
  error => Promise.reject(error)
);

// 响应拦截
service.interceptors.response.use(
  res => res.data,
  e => {
    switch (e.response || e.response.status) {
      case 417:
        EventBus.$emit("errorNotify", {
          message: e.response.data.msg
        });
        break;

      default:
        break;
    }
    return Promise.reject(e);
  }
);

export default service;
